import { useCallback, useEffect, useState } from 'react';
import { loadStripeTerminal } from '@stripe/terminal-js';

import { doSwaggerCall } from './useSwaggerClient';
import { useStore } from 'react-redux';

const isRealDevices = () => {
    return (
        window.location.href.indexOf('localhost') === -1 &&
        window.location.href.indexOf('127.0.0.1') === -1
    );
};

export function useStripeTerminal(methodSlug) {
    const store = useStore();
    const { location } = window.clientData;
    const [terminal, setTerminal] = useState(null);
    const [readers, setReaders] = useState(null);
    const [loading, setLoading] = useState('');
    const [error, setError] = useState(null);
    const [readerData, setReaderData] = useState({ simulated: !isRealDevices() });

    useEffect(() => {
        if (isRealDevices()) {
            setReaderData({ location: location.id });
        }
    }, [location, setReaderData]);

    useEffect(() => {
        if (!terminal) {
            setLoading('Loading...');
            loadStripeTerminal()
                .then(StripeTerminal => {
                    const t = StripeTerminal.create({
                        onFetchConnectionToken: () =>
                            doSwaggerCall('bookings', 'getConnectionToken', {}).then(
                                response => response.secret
                            ),
                        onUnexpectedReaderDisconnect: () => {
                            setError('Reader disconnected');
                        }
                    });
                    setTerminal(t);
                    return t.discoverReaders(readerData);
                })
                .then(discoverResult => {
                    setReaders(discoverResult.discoveredReaders);
                    setLoading('');
                })
                .catch(err => {
                    setLoading('');
                    setError(err);
                });
        }
    }, []);

    const waitForReader = useCallback(
        async (reader, newBooking) => {
            if (terminal) {
                setLoading('Waiting for connection...');
                try {
                    console.log(reader);
                    const res = await terminal.connectReader(reader);
                    console.log(res);

                    const discounts = store.getState().cart.discount;

                    const { secret } = await doSwaggerCall(
                        'terminals',
                        'initializeTerminalPayment',
                        {
                            newBooking: {
                                ...newBooking,
                                discounts
                            },
                            methodSlug
                        }
                    );
                    setLoading('Read the card with the terminal...');
                    if (readerData.simulated) {
                        terminal.setSimulatorConfiguration({ testCardNumber: '4242424242424242' });
                    }
                    const { paymentIntent } = await terminal.collectPaymentMethod(secret);
                    const result = await terminal.processPayment(paymentIntent);
                    if (result.error) {
                        throw new Error(result.error.message);
                    }
                    setLoading('');
                    return { paymentIntent: result.paymentIntent.id };
                } catch (err) {
                    setLoading('');
                    setError(err);
                }
            }
            return undefined;
        },
        [terminal, store, methodSlug, readerData.simulated]
    );

    const reset = useCallback(async () => {
        setLoading('Disconnecting...');
        await terminal.disconnectReader();
        setError(null);
        setLoading('');
    }, [terminal]);

    return {
        readers,
        loading,
        error,
        waitForReader,
        reset
    };
}
